import { Toaster } from 'lqa-ui/lib/Components/Toaster/index';

const showMessage = (intent: 'success' | 'danger', text: string) => (
    Toaster.addToast({
        intent,
        text,
    }));

export const showErrorMessage = (text: string) => showMessage('danger', text);
export const showSuccessMessage = (text: string) => showMessage('success', text);
